import aesReduxConstants from '../../constants';
import accessLogApi from '../../apis/accessLogApi';

const accessLogActions = function() {
  const factory = {};
  const constants = aesReduxConstants.AFB_TOOLS;

  factory.getLoginAttemptsSuccess = function(response) {
    const { list } = response.data;
    const numResults = response.data.total;

    return {
      type: constants.GET_LOGIN_ATTEMPTS_SUCCESS,
      list,
      numResults,
    };
  };

  factory.getLoginAttemptsError = function() {
    return {
      type: constants.GET_LOGIN_ATTEMPTS_ERROR,
    };
  };

  factory.getLoginAttempts = function(page, limit, username, startTime, endTime, appTypeId, appVersion) {
    return function(dispatch) {
      accessLogApi.getLoginAttempts(page, limit, username, startTime, endTime, appTypeId, appVersion)
        .then((response) => {
          dispatch(factory.getLoginAttemptsSuccess(response));
        }, (error) => {
          dispatch(factory.getLoginAttemptsError(error));
        });
    };
  };

  factory.getAppTypesSuccess = function(response) {
    const list = response.data;

    return {
      type: constants.GET_APP_TYPES_SUCCESS,
      list,
    };
  };

  factory.getAppTypesError = function(error) {
    return {
      type: constants.GET_APP_TYPES_ERROR,
    };
  };

  factory.getAppTypes = function() {
    return function(dispatch) {
      accessLogApi.getAppTypes()
        .then((response) => {
          dispatch(factory.getAppTypesSuccess(response));
        }, (error) => {
          dispatch(factory.getAppTypesError(error));
        });
    };
  };

  return factory;
};

export default accessLogActions();
